import FramePage from "./mainComponents/main/frame";
import useObjectState from "../../utils/useObjectState";
import ProjectScreen from "./mainScreens/projectScreen";
import { useEffect, useState } from "react";
import HistoryScreen from "./mainScreens/historyScreen";
import ProjectsScreen from "./mainScreens/projectsScreen";
import TopBar from "./mainComponents/main/topBar";
import DashboardScreen from "./mainScreens/dashboardScreen";
import UnderConstructionScreen from "./mainScreens/underConstructionScreen";
import ProfileScreen from "./mainScreens/profileScreen";
import NotifSettingsScreen from "./mainScreens/notifSettingsScreen";
import DevicesScreen from "./mainScreens/devicesScreen";
import DeviceDetailsScreen from "./mainScreens/deviceDetailsScreen";
import AlertListScreen from "./mainScreens/alertListScreen";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

export default function MainPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [state, setState] = useObjectState({
    ecois_tokenExpiresAt: localStorage.getItem("ecois_tokenExpiresAt"),
    tokenExpiresAt: localStorage.getItem("tokenExpiresAt"),
    ecois_token: localStorage.getItem("ecois_token"),
    token: localStorage.getItem("token"),
    pageTab: "dashboard",
    pageTabStack: [],
    pageIdxStack: [],
    pageIdx: 0,
  });
  const [projectState, setProjectState] = useObjectState({
    selectedProject: null,
  });
  const [historyState, setHistoryState] = useObjectState({
    project: null,
    history: {
      sn: null,
      seriesAbbr: null,
      from: null,
      to: null,
      availableTypes: null,
      latest: null,
    },
  });

  const [deviceDetailsState, setDeviceDetailsState] = useObjectState({
    project: null,
    device: null,
  });
  const [topBarState, setTopBarState] = useObjectState({ firstname: null, alerts: [] });
  const tokenExpiresAt = localStorage.getItem("tokenExpiresAt");
  const isLogin = tokenExpiresAt !== null && tokenExpiresAt > Date.now();

  useEffect(() => {
    if (!isLogin) {
      localStorage.removeItem("tokenExpiresAt");
      if (tokenExpiresAt !== null) {
        Swal.fire("已逾時登出", `<div style='flex flex-start'><h4>自動跳轉到首頁</h4></div>`);
      }
      navigate("/landing");
    }
  }, [isLogin]);

  useEffect(() => {
    const hash = location.hash.slice(1); // Remove the '#'
    if (hash) {
      const tab = hash;
      setState({ pageTab: tab });
    }
  }, [location]);

  if (!isLogin) return <></>;

  const handleTabChange = (tab, idx = 0) => {
    setState({ pageTab: tab, pageIdx: idx });
    navigate(`#${tab}`);
  };

  const getPage = (tab, idx) => {
    return {
      dashboard: [
        <DashboardScreen
          setProjectState={setProjectState}
          setState={setState}
          state={state}
          onTabChange={handleTabChange}
        />,
      ],
      projects: [
        <ProjectsScreen
          state={state}
          setState={setState}
          setProjectState={setProjectState}
          topBarState={topBarState}
        />,
        <ProjectScreen
          state={state}
          setState={setState}
          projectState={projectState}
          historyState={historyState}
          setHistoryState={setHistoryState}
          topBarState={topBarState}
          setDeviceDetailsState={setDeviceDetailsState}
        />,
      ],
      devices: [
        <DevicesScreen
          state={state}
          setState={setState}
          setProjectState={setProjectState}
          historyState={historyState}
          setHistoryState={setHistoryState}
          topBarState={topBarState}
          setDeviceDetailsState={setDeviceDetailsState}
        />,
      ],
      notif_settings: [<NotifSettingsScreen />],
      profile: [<ProfileScreen setTopBarState={setTopBarState} />],
      history: [<></>, <HistoryScreen historyProps={historyState.history} />], //tab - less
      deviceDetails: [<></>, <DeviceDetailsScreen deviceDetailsProps={deviceDetailsState} />], //tab - less
      alertlist: [<AlertListScreen setTopBarState={setTopBarState} />],
    }[tab][idx];
  };

  const currentStack = {
    dashboard: [t("main.topbar_dashboard")],
    projects: [t("main.topbar_projects"), projectState.selectedProject?.alias ?? "(沒有名字)"],
    devices: [t("main.topbar_devices")],
    notif_settings: [t("main.topbar_notif_settings")],
    profile: [t("main.topbar_profile")],
    history: [null, `${historyState.project ?? "(沒有名字)"} - ${historyState.history.sn} 歷史`],
    deviceDetails: [null, `Device Details`],
    alertlist: [`Alert List`],
  }[state.pageTab][state.pageIdx];

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <>
          <TopBar
            setState={setState}
            state={state}
            topBarState={topBarState}
            setTopBarState={setTopBarState}
            currentStack={currentStack}
            onTabChange={handleTabChange}
          />
          <FramePage>{getPage(state.pageTab, state.pageIdx)}</FramePage>
        </>
      </div>
    </>
  );
}
